var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2057 2.48035H3.8724C3.13906 2.48035 2.53906 3.08035 2.53906 3.81368V13.147C2.53906 13.8803 3.13906 14.4803 3.8724 14.4803H13.2057C13.9391 14.4803 14.5391 13.8803 14.5391 13.147V3.81368C14.5391 3.08035 13.9391 2.48035 13.2057 2.48035ZM13.2057 13.147H3.8724V3.81368H13.2057V13.147Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20605 8.48037H6.53939V11.8137H5.20605V8.48037ZM10.5394 5.14703H11.8727V11.8137H10.5394V5.14703ZM7.87272 9.8137H9.20605V11.8137H7.87272V9.8137ZM7.87272 7.14703H9.20605V8.48037H7.87272V7.14703Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportAnalytics);
export default __webpack_public_path__ + "static/media/report-analytics.99f95efb71ba61a7345e5da5638b2a6a.svg";
export { ForwardRef as ReactComponent };